import { useCallback } from "react";
import * as auth from "@/services/auth";

interface UseAuthenticationParams {
  destroySession: () => Promise<void>;
  initializeSession: () => Promise<void>;
  setImpersonateCognitoId: (value: string | null) => void;
  setImpersonationReturnPath: (path: string | null) => void;
}

export const useAuthentication = ({
  destroySession,
  initializeSession,
  setImpersonateCognitoId,
  setImpersonationReturnPath,
}: UseAuthenticationParams) => {
  const handleLogin = useCallback(
    async (username: string, password: string) => {
      await destroySession();
      await auth.signIn(username, password);
      await initializeSession();
    },
    [destroySession, initializeSession],
  );

  const isSignedIn = useCallback(() => {
    return auth.isSignedIn();
  }, []);

  const handleLogout = useCallback(() => {
    setImpersonateCognitoId(null);
    setImpersonationReturnPath(null);
    auth.signOut();
    destroySession();
  }, [destroySession, setImpersonateCognitoId, setImpersonationReturnPath]);

  return {
    handleLogin,
    isSignedIn,
    handleLogout,
  };
};
